import { handleGetRequest } from "./http.service";

export interface AgencyUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface Agency {
  _id: string;
  name?: string;
  companyEmail?: string;
  phoneNumber?: string;
  state?: string;
  lga?: string;
  officeAddress?: string;
  type?: string;
  cacNumber?: string;
  agencyVerified?: boolean;
  profilePicture?: { url: string };
  user: AgencyUser;
  createdAt: string;
}

export interface AgenciesResponse {
  page: number;
  limit: number;
  total: number;
  data: Agency[];
}

export const getAllAgencies = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.search) qs.set("search", params.search);
  const query = qs.toString() ? `?${qs}` : "";
  return handleGetRequest<AgenciesResponse>(`/agency${query}`);
};
